import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InfosService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}
  headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
  requestOptions: Object = {
    headers: this.headers,
    responseType: 'text',
  };

  headersInstallationPhoto = {
    responseType: 'blob' as 'json',
    withCredentials: true,
  };
  public getGateways(): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiServerUrl}/api/others/statusGateways`
    );
  }

  public getBaseHealth(): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiServerUrl}/report/requestSummarizedPositionsDashboard`
    );
  }
  public getBaseHealthA40B(): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiServerUrl}/report/requestSummarizedPositionsDashboardA40B`
    );
  }

  public getBaseMEGAHealth(): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiServerUrl}/report/requestMEGAAnalyticsDashboard`
    );
  }
  public getNewsletter(): Observable<any> {
    return this.http.get<any[]>(
      `${this.apiServerUrl}/report/requestNewsletter`
    );
  }
  public getInstallationPhoto(urlFile: string): Observable<any> {
    return this.http.post<any[]>(
      `${this.apiServerUrl}/report/request/getImage`,
      urlFile,
      this.headersInstallationPhoto
    );
  }
  public getWorkerCommandsAuto() : Observable<any[]> {
    return this.http.get<any>(
      `${this.apiServerUrl}/report/requestWorkerCommandsAuto`,
      { withCredentials: true}
    )
  }
}
